import React from "react";
import { useTranslation } from "react-i18next";
import { FormikFormGroup } from "components/common";
const ArchiveBackendNameDescriptionFormGroup = () => {
  const { t } = useTranslation("enterprise_archive");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      name: "title",
      label: t("archive_backend_name_description_form_group.title_label"),
      required: true,
      help: t("archive_backend_name_description_form_group.title_help"),
      labelClassName: "",
      wrapperClassName: ""
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      name: "description",
      label: t("archive_backend_name_description_form_group.description_label"),
      required: true,
      help: t("archive_backend_name_description_form_group.description_help"),
      labelClassName: "",
      wrapperClassName: ""
    }
  ));
};
export default ArchiveBackendNameDescriptionFormGroup;
